import React from "react";
import student from "../../assets/images/pictograms/working.svg";
import employer from "../../assets/images/pictograms/hire.svg";

function SignUp() {
  return (
    <div className="purple-container px-lg-5">
      <div className="container py-5">
        <div className="row mx-lg-5">
          <a
            href="https://forms.office.com/r/wyxaGwABEM"
            className="col-lg-6 col-12 mt-auto mb-5"
          >
            <span>
              <img
                src={student}
                className="pictogram-sign-up pb-5"
                alt="Students"
              />
              <h4>Student Registration</h4>
            </span>
          </a>
          <a
            href="mailto:msaccelerate@hotmail.com?subject=MSA Employer Registration"
            className="col-lg-6 col-12 mt-auto  mb-5"
          >
            <span>
              <img
                src={employer}
                className="pictogram-sign-up pb-5"
                alt="Employers"
              />
              <h4>Employer Registration</h4>
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default SignUp;
